export const refs = {
  gallery: document.querySelector(`.card__list`),
  weather: document.querySelector(`.weather`),
  filter: document.querySelector(`.search-form`),
  filterBtn: document.querySelector(`.js-button-search`),
  filterInput: document.querySelector(`.form__input-close`),
  calendar: document.querySelector(`.calendar`),
  calendarInput: document.querySelector(`.calendar__input`),
  FavBtn: document.querySelector('.js-favorite'),

  categoriesBtnMenu: document.querySelector('.categories__btn-menu'),
  categoriesBox: document.querySelector('.categories'),
  categoriesList: document.querySelector('.categories__list'),
  categoriesMenu: document.querySelector('.categories__menu'),
  categoriesContainer: document.querySelector('.filter-container'),
  menu: document.querySelector('.menu'),
  categoriesIconUp: document.querySelector('.categories__icon-up'),
  categoriesIconDown: document.querySelector('.categories__icon-down'),
  categoriesBtnList: document.querySelector('.categories__btn-list'),

  categoriesBtnMenuText: document.querySelector('.categories__btn-text'),
  notFoundEl: document.querySelector('.not-found'),
  buttonEL: document.querySelector('.js-button-search'),
  inputEl: document.querySelector('.form__input-close'),
  svgEl: document.querySelector('.search__icon-hidden'),
  iconBtn: document.querySelector('.icon__button-hidden'),

  mobileNavItem: document.querySelector('.mobile-menu-list'),

  //accordion
  accordion: document.querySelector('.accordion'),
  accordArrow: document.querySelector('.accord__arrow'),
  //Read more && Add
  readMore: document.querySelector('.info__link'),

  //nav main btn
  ReadBtn: document.querySelector('[data-value="Read"]'),
  FavBtn: document.querySelector('[data-value="Favorite"]'),
  HomeBtn: document.querySelector('[data-value="Home"]'),
  // nav mobile btn
  readBtnMob: document.querySelector('.js-read'),
  favBtnMob: document.querySelector('.js-favorite'),
  homeBtnMob: document.querySelector('.js-home'),

  nav : document.querySelector(".list-navigation"),
  navMobile : document.querySelector(".mobile-menu-list"),
  categContainer : document.querySelector(".filter-container"),
  loader : document.querySelector(".loader"),
  mobileMenu: document.querySelector('.js-menu-container'),
  //pagination 
  pageContainer : document.querySelector('.page-container'),
  pg : document.getElementById('pagination'),
  btnNextPg : document.querySelector('button.next-page'),
  btnPrevPg : document.querySelector('button.prev-page'),
  
  
};
